import { showErrorToast } from "../../components/toast.component";
import { AppRouteApi } from "../../config/appRoute";
import { ApiResponseContainer, ApiSchemaCardDetails } from "../../models/api";
import { AxiosAuth } from "../axios";
import { StorageAuth } from "../localStorage";

async function GetCardDetails(): Promise<
  ApiResponseContainer<ApiSchemaCardDetails>
> {
  try {
    const response = await AxiosAuth.get<
      ApiResponseContainer<ApiSchemaCardDetails>
    >(AppRouteApi.PaymentCard.PaymentCardDetails(StorageAuth.CompanyId!));
    return response.data;
  } catch (error: any) {
    console.error(error);
    return showErrorToast({
      isSuccess: false,
      ...JSON.parse(error.message).data,
    });
  }
}

async function GetStripeSessionId(data: {
  CompanyId: string;
  SuccessUrl: string;
  CancelUrl: string;
}): Promise<ApiResponseContainer<string>> {
  try {
    const response = await AxiosAuth.put<ApiResponseContainer<string>>(
      AppRouteApi.PaymentCard.UpdatePaymentCard(),
      data
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    return showErrorToast({
      isSuccess: false,
      ...JSON.parse(error.message).data,
    });
  }
}

export const ApiBilling = {
  GetCardDetails,
  GetStripeSessionId,
};
